export enum EEntity {
  CLIENT = 'client',
  COMPANY = 'company',
  OTHER = 'other'
}
